export const BACKEND_ENDPOINT = "https://novelfy-be.onrender.com";
// export const BACKEND_ENDPOINT = "http://localhost:5500";
export const NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY =
  "pk_test_51On43nKAhEtER47i8gd5zDcaw7EJNSu3j8Gg8klGYNMf3njis2lVkQhPLatlYkKg3uFRiFc7R6es6L4sDkJw2nC800WL1taXfG";
